import { stateAbbreviationValidator, formatCityFromLink } from "./mortgage-helpers.esm.js";
import { REGIONALIZED_PAGES } from "./constants.esm.js";
import { getFullNameFromAbbr } from "../../node_modules/@zillow/state-region-id-map/dist/state-region-id-map.esm.esm.js";
const urlInfo = (pathname = typeof location !== "undefined" && location.pathname) => {
  const info = {};
  if (pathname) {
    const segments = pathname.split("/");
    info.page = segments[1];
    info.segments = segments.slice(1);
    if (info.segments[info.segments.length - 1] === "") {
      info.segments.pop();
    }
    if (REGIONALIZED_PAGES.indexOf(info.page) >= 0) {
      const modifier = segments[2];
      const stateAbbreviation = modifier && modifier.toUpperCase();
      if (stateAbbreviationValidator(stateAbbreviation)) {
        info.region = {
          path: modifier + "/",
          stateAbbreviation,
          stateName: getFullNameFromAbbr(stateAbbreviation)
        };
        if (segments[3]) {
          info.region.path += segments[3] + "/";
          info.region.city = formatCityFromLink(segments[3]);
        }
      }
    }
  }
  return info;
};
export {
  urlInfo as default
};
